/** Browser crypto failures may have an empty message. Keep their meaning visible. */
export function recoveryErrorMessage(error: unknown): string {
  if (
    error &&
    typeof error === "object" &&
    "name" in error &&
    error.name === "OperationError"
  ) {
    return "Encrypted data could not be decrypted or authenticated with the current privacy keys";
  }
  if (error instanceof Error)
    return error.message.trim() || error.name || "Unknown error";
  if (typeof error === "string") return error.trim() || "Unknown error";
  return "Unknown error";
}
